module.exports = "./img/6ed2cb56965dd8ed6b130a5bc1ea5376.jpg";